export default "__VITE_ASSET__CWnTi44m__"